/**
 * Created by Reda on 21.10.26
 */

cleverapps.whenAllInitialized(() => {
    if (cleverapps.abExperiments.getGroup(ABExperiments.Tests.hungryGamesBalance) === "A") {
        RewardsConfig.HungryGames.value = 1500;
        [6, 8, 6, 10, 6, 6, 10].forEach((ingredientAmount, level) => {
            HungryGamesCustomer.RECIPES_CONFIG[level].ingredients[0].amount = ingredientAmount;
        });
        HungryGamesCustomer.LEVEL_DURATION = cleverapps.parseInterval("1 hour");
        HungryGamesLogic.generateEliminationRate = function () {
            const winners = 12 + Math.floor(Math.random() * 5);
            return Math.pow(winners / HungryGamesLogic.PLAYERS_AMOUNT, 1 / HungryGamesLogic.LEVELS_AMOUNT);
        };
    }
});